module.exports = __webpack_public_path__ + "static/media/circle1@2x.7ee1649e.png";